import { Component, OnInit } from '@angular/core';
import { environment } from '@env/environment';

@Component({
  selector: 'cd-not-found404',
  templateUrl: './not-found404.component.html',
  styleUrls: ['./not-found404.component.scss'],
})
export class NotFound404Component implements OnInit {
  readonly staticUrl = environment.staticUrl;

  constructor() {
    document.body.className = 'form-wrapper error-wrapper error-wrapper-page page-black'
  }

  ngOnInit(): void {
  }

}
